import { useCallback, useEffect, useRef } from "react"

// main use case for this is when you want to run a cleanup callback but the callback has dependencies

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const useNonReactiveCallback = <T extends Function>(callback: T, deps: unknown[]) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const cb = useCallback(callback, deps)
    const callbackRef = useRef(cb)
    useEffect(() => {
        callbackRef.current = cb
    }, [cb])
    return callbackRef
}
